import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/PolicyPages.css";

const BookingProcess = () => {
  return (
    <>
      <Header />

      <div className="policy-hero">
        <h1>How Your Ranthambore Trip is Planned</h1>
        <p>
          Understand how we assist you in planning your Ranthambore tour
          including safari experiences and travel arrangements.
        </p>
      </div>

      <div className="policy-wrapper">

        {/* STEP 1 */}
        <div className="policy-section">
          <h2>1. Share Your Travel Details</h2>
          <p>
            You can submit your travel enquiry through our website or contact
            us via phone or WhatsApp. Share your preferred travel dates,
            number of travelers, and general preferences.
          </p>
        </div>

        {/* STEP 2 */}
        <div className="policy-section">
          <h2>2. Travel Planning & Suggestions</h2>
          <p>
            Based on your requirements, we suggest suitable Ranthambore tour
            packages including accommodation options and safari experience
            planning through authorised operators.
          </p>
        </div>

        {/* STEP 3 */}
        <div className="policy-section">
          <h2>3. Travel Coordination</h2>
          <p>
            Once you confirm your preference, we assist in coordinating travel
            components such as safari experience, stay, and local arrangements
            based on availability and operator policies.
          </p>
        </div>

        {/* STEP 4 */}
        <div className="policy-section">
          <h2>4. Confirmation Details</h2>
          <p>
            After arrangements are confirmed, you will receive details such as
            travel dates, reporting time, and important instructions for your
            Ranthambore visit.
          </p>
        </div>

        {/* STEP 5 */}
        <div className="policy-section">
          <h2>5. Enjoy Your Trip</h2>
          <p>
            Experience Ranthambore with complete travel support and guidance.
            Our team remains available for assistance throughout your journey.
          </p>
        </div>

        {/* INFO */}
        <div className="policy-section">
          <h2>Important Information</h2>
          <p>
            Ranthambore Tours & Travel Assistance is a registered MSME enterprise
            based in Gurgaon, Haryana. We provide travel planning services to
            help visitors organise Ranthambore trips including safari experiences,
            accommodation, and local support.
          </p>

          <p>
            We are not affiliated with the Forest Department or any government
            authority and do not operate safari vehicles directly. All safari
            experiences are conducted by authorised operators as per park regulations.
          </p>
        </div>

        {/* CONTACT */}
        <div className="policy-section">
          <h2>Contact Information</h2>
          <p>
            <strong>Business Name:</strong> Ranthambore Tours & Travel Assistance <br />
            <strong>Location:</strong> Gurgaon, Haryana, India <br />
            <strong>Phone:</strong> +91-9217691062 <br />
            <strong>Email:</strong> support@safariranthamborebooking.com
          </p>
        </div>

      </div>

      
    </>
  );
};

export default BookingProcess;